import { useCurrentUser } from '../../../../hooks/current-user/current-user';
import { useQResourceContext } from '../../../../QLayouts/QResourceRoutes/context';
import { useQuery, UseQueryResult } from 'react-query';
import { MedtechUser } from './types';

type UsersData = {
  users: MedtechUser[];
  usersById: Record<number, MedtechUser>;
};

export const useUsers = (): UseQueryResult<UsersData, unknown> => {
  const user = useCurrentUser();
  const { mtbeClient } = useQResourceContext();

  return useQuery({
    queryKey: ['USERS', user.companyId],
    queryFn: async () =>
      MedtechUser.array().parse(
        (await mtbeClient.get(`/v3/${user.companyId}/users`)).data,
      ),
    select: (data) => ({
      users: data.filter((user) => user.active),
      usersById: Object.fromEntries(
        data.filter((user) => user.active).map((user) => [user.user_id, user]),
      ) as Record<number, MedtechUser>,
    }),
    cacheTime: 10 * 60 * 1000,
  });
};
